import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LazadaOpenService, LexDocService } from 'src/app/shared/services';
import { lazadaStoreProviders } from 'src/app/shared/config/store-config';
import { LazadaOrdersComponent } from '../../../shared/components/lazada-orders/lazada-orders.component';

@Component({
    selector: 'app-quick-orders',
    templateUrl: './lazada-order-page.component.html',
    styleUrls: ['./lazada-order-page.component.scss'],
    providers: [
        ...lazadaStoreProviders('lazada-genlogic'),
        LazadaOpenService,
        LexDocService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LazadaOrdersComponent],
})
export class LazadaOrderPageComponent {
    constructor() {}
}
